export const filtersSerializer = (params) => {
  return `filters=${JSON.stringify(params.filters)}`;
};

export const buildFilter = ({
  field,
  operation,
  value,
  combineHash = null,
}) => {
  let filter = {};
  filter[field] = { op: operation, value: value, c: combineHash };
  return filter;
};

export const getConstDateWithoutRegion = (dateString) => {
  if (
    typeof dateString === "string" &&
    dateString !== ""
  ) {
    let curDate = new Date(dateString);
    let year = curDate.getUTCFullYear();
    let monthIndex = curDate.getUTCMonth();
    let day = curDate.getUTCDate();
    return new Date(year, monthIndex, day);
  }
  return null
}

export const parseCSVLine = (line) => {
  const values = [];
  let currentValue = "";
  let inQuotes = false;
  let i = 0;

  while (i < line.length) {
    const char = line[i];

    if (char === '"') {
      if (inQuotes && line[i + 1] === '"') {
        // Escaped quote - add a single quote
        currentValue += '"';
        i += 2;
      } else {
        // Toggle quote state
        inQuotes = !inQuotes;
        i++;
      }
    } else if (char === ',' && !inQuotes) {
      // Comma outside quotes - end of field
      values.push(currentValue);
      currentValue = "";
      i++;
    } else {
      // Regular character
      currentValue += char;
      i++;
    }
  }
  // Add the last value
  values.push(currentValue);

  return values;
};
